//==============================
// Header
//==============================

var header = $('.header');
var button = $('.header-nav-button');
var nav = $('.header-nav');
var subnav = $('.sub-nav');

// button
button.click(function() {
  header.toggleClass('open');
  button.toggleClass('open');
  nav.toggleClass('open');
});

// scroll
function headerNotTop() {
  header.addClass('scroll');
  subnav.addClass('scroll');
}
function headerAtTop() {
  header.removeClass('scroll');
  subnav.removeClass('scroll');
}
function headerScroll() {
  var scrollPos = $(window).scrollTop();
  if (scrollPos<=30) {
    headerAtTop();
  }
  else {
    headerNotTop();
  }
}

headerScroll();

$(window).scroll(function() {
  headerScroll();
});

$('.sub-nav a').focus(function() {
  console.log('derp');
  subnav.addClass('focus');
});

$('.sub-nav a').blur(function() {
  console.log('derp');
  subnav.removeClass('focus');
});
